import React from 'react'

import Authors from './Authors'
import Topics from './Topics'
import Stats from './Stats'
import Pricing from './Pricing'
import Links from './Links'

const BelowFold = () => (
  <div className="BelowFold">
    <Authors />
    <Topics />
    <Stats />
    <Pricing />
    <Links />
  </div>
)

export default BelowFold



// WEBPACK FOOTER //
// ./src/components/landing/BelowFold.js